<nav #navbar class="navbar">
    <div class="container-fluid">
        <div class="navbar-header">
            <a href="#" onClick="return false;" class="navbar-toggle collapsed"
               (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
            <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
            <a class="navbar-brand" routerLink="dashboard/main">
                <!-- <img src="assets/cropped-logo.png" alt=""  /> -->
                <span class="logo-name">Accesslife</span>
            </a>
        </div>
        <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
            <ul class="pull-left collapse-menu-icon">
                <li class="menuBtn">
                    <button mat-button (click)="callSidemenuCollapse()" class="sidemenu-collapse nav-notification-icons">
                        <app-feather-icons [icon]="'menu'" [class]="'header-icon'"></app-feather-icons>
                    </button>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <!-- Full Screen Button -->
                <li class="fullscreen">
                    <button mat-button class="nav-notification-icons" (click)="callFullscreen()">
                        <app-feather-icons [icon]="'maximize'" [class]="'header-icon'"></app-feather-icons>
                    </button>
                </li>
                <!-- #END# Full Screen Button -->
                <!-- #START# Notifications-->
                <li class="nav-item" ngbDropdown>
                    <button mat-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons">
                        <app-feather-icons [icon]="'bell'" [class]="'header-icon'"></app-feather-icons>
                        <span class="notify" *ngIf="unreadCount > 0">{{unreadCount}}</span>
                        <span class="heartbeat" *ngIf="unreadCount > 0"></span>
                    </button>
                    <mat-menu #notificationMenu="matMenu" class="nfc-menu" xPosition="before">
                        <div class="nfc-header">
                            <h5 class="mb-0">Notifications</h5>
                            <a class="nfc-mark-as-read" (click)="markAllAsRead()">Mark all as read</a>
                        </div>
                        <div class="nfc-dropdown">
                            <ng-scrollbar style="height: 350px" visibility="hover">
                                <div class="noti-list header-menu">
                                    <div class="menu">
                                        <div class="notification-content" *ngFor="let notification of notifications$ | async"
                                             (click)="handleNotificationClick(notification)"
                                             [class]="notification.status">
                                            <div class="icon-wrapper" [style.background-color]="notification.color|| '#f8a552'">
                                                <mat-icon>{{notification.icon}}</mat-icon>
                                            </div>
                                            <div class="notification-info">
                                                <div class="notification-message">{{notification.message}}</div>
                                                <div class="notification-time">{{getTimeAgo(notification.time)}}</div>
                                            </div>
                                            <div class="notification-actions">
                                                <button mat-icon-button (click)="markAsRead(notification.id, $event)"
                                                        *ngIf="notification.status === 'msg-unread'">
                                                    <mat-icon>check</mat-icon>
                                                </button>
                                                <button mat-icon-button (click)="deleteNotification(notification.id, $event)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-scrollbar>
                        </div>
                        <div class="nfc-footer">
<div class="d-flex justify-content-around">
                            <a class="nfc-read-all" (click)="markAllAsRead()">Read All Notifications</a>
                            <a class="nfc-read-all" (click)="viewAllAlerts()">View Notifications</a>
</div>
                        </div>
                    </mat-menu>
                </li>
                <!-- #END# Notifications-->
                <li class="nav-item user_profile">
                    <button mat-button [matMenuTriggerFor]="profilemenu">
                        <div class="chip dropdown-toggle" ngbDropdownToggle>
                            <img [src]="userData?.profileImages ?? 'assets/images/userbig.png'" class="rounded-circle" width="32" height="32" alt="User">
                        </div>
                    </button>
                    <mat-menu #profilemenu="matMenu" class="profile-menu">
                        <div class="noti-list">
                            <div class="menu">
                                <div class="user_dw_menu">
                                    <button mat-menu-item (click)="openAccount()">
                                        <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
                                    </button>
                                    <!--
                                    <button mat-menu-item>
                                      <app-feather-icons [icon]="'mail'" [class]="'user-menu-icons'"></app-feather-icons>Inbox
                                    </button>
                                    <button mat-menu-item>
                                      <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
                                    </button>
                                    -->
                                    <button mat-menu-item (click)="logout()">
                                        <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>Logout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-menu>
                </li>
            </ul>
        </div>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</nav>
